import { useAccount } from 'wagmi'
import TokenLogo from '~/components/TokenLogo'
import { Column } from '~/components/Layout'
import { formatAmount, formatFormAmount } from '~/utils/numbers'
import styled from 'styled-components'

export interface Token extends BaseTokenlonToken {
  balance: string
  priceUSD: string
}

interface Props {
  token: Token
  onSelect: (token: ERC20Token) => void
}

const TokenListItem: React.FC<Props> = ({ token, onSelect }) => {
  const { address: account } = useAccount()
  const { logo, symbol, balance, priceUSD } = token

  return (
    <ListItem onClick={() => onSelect(token)}>
      <TokenLogo large logo={logo} symbol={symbol} space={0} />

      <div className="item-right">
        <Column>
          <StyledSymbol>{symbol}</StyledSymbol>
        </Column>
        {account ? (
          <div className="token-account-info">
            <span className="balance">{formatFormAmount(balance ?? 0, 4)}</span>
            {!!Number(priceUSD) && (
              <span className="priceUSD">${formatAmount(priceUSD, 2)}</span>
            )}
          </div>
        ) : null}
      </div>
    </ListItem>
  )
}

export default TokenListItem

const ListItem = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.colors.bgSurface};
  }

  .item-right {
    border-bottom: 0.5px solid ${({ theme }) => theme.colors.borderDefault};
    display: flex;
    flex: 1;
    justify-content: space-between;
    align-items: center;
    padding: 17px 0;
    padding-right: 17.5px;
    min-height: 70px;
    margin-left: 8px;
  }

  .token-name {
    font-size: 13px;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.textTertiary};
  }

  .token-user-add {
    font-weight: 300;
    font-size: 13px;
    line-height: 17px;
    color: ${({ theme }) => theme.colors.textTertiary};
  }

  .token-account-info {
    display: inline-flex;
    flex-direction: column;
    text-align: right;
  }

  .balance {
    font-weight: 500;
    font-size: 17px;
    line-height: 15px;
    color: ${({ theme }) => theme.colors.textTitle};
    margin: 0;
  }

  .priceUSD {
    font-weight: normal;
    font-size: 13px;
    line-height: 11px;
    color: ${({ theme }) => theme.colors.textTertiary};
    margin-top: 9px;
  }
`

const StyledSymbol = styled.div`
  font-size: 17px;
  line-height: 23.15px;
  color: ${({ theme }) => theme.colors.textTitle};
`
